export default __webpack_public_path__ + "files/RP4_General_barriers_and_opportunities_for_policies_in_bioeconomy.docx";